<template>
  <div class="video-item" :class="{ disabled: disabled, shadow: shadow }">
    <!-- -->
    <template v-if="data.videotitle">
      <a
        class="img img-con"
        @click="detial(aHref)"
        target="_blank"
        style="background-color: #000"
      >
        <el-image :src="disabled ? '' : coverUrl" class="cover" fit="contain"></el-image>
        <i class="iconfont"> &#xe610; </i>
        <span class="time" v-if="data.duration">{{ formaStr(data.duration) }}</span>
      </a>

      <div class="info">
        <a class="title" @click="detial(aHref)" target="_blank">
          {{ disabled ? "该视频不存在" : data.videotitle }}
        </a>

        <div class="foot">
          <div class="playtime">播放{{ data.viewamount || 0 }}次</div>
          <div class="right-info">
            <item-tool-bar
              :layout="toolLayout"
              :data="data"
              type="video"
              :rowguid="data.guid"
              @like="$emit('like')"
              @collect="$emit('collect')"
            ></item-tool-bar>
          </div>
        </div>
      </div>
    </template>

    <div v-else class="placeholder">
      <div class="img-plh"></div>
    </div>
  </div>
</template>

<script>
import itemToolBar from "@components/sys/item-tool-bar/index";
import adduserInfo from "@components/sys/adduser-info";
export default {
  components: {
    itemToolBar,
    adduserInfo,
  },
  props: {
    data: {
      type: Object,
      default: () => ({}),
    },
    index: {
      type: Boolean,
      default: true,
    },
    toolLayout: {
      type: String,
      default: "addtime",
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    shadow: {
      type: Boolean,
      default: false,
    },
    visitlocation: {
      type: String,
      default: "课程视频",
    },
  },
  data() {
    return {};
  },
  computed: {
    aHref() {
      return `/video/${this.data.guid}`;
    },
    coverUrl() {
      var coverFileList = this.data.coverfilelist || [],
        firstFile = coverFileList[0] || {},
        filesavepath = firstFile.filesavepath;

      return filesavepath;
    },
  },
  methods: {
    //查看详情
    detial(aHref) {
      this.$store.dispatch("analysis/updateHits", {
        visitlocation: "课程视频-详情",
      });
      this.$get(`${this.$store.state.api.webUrl}/setup/getuserinfo.json`, (data) => {
        window.location.assign(aHref);
      });
    },
    // 返回秒数,计算为分钟时长
    formaStr(val) {
      if (val) {
        if (val >= 60) {
          var min = parseInt(val / 60);
          var seconds = parseInt(val - min * 60);
          return min < 10
            ? "0" + min
            : min + ":" + (seconds < 10 ? "0" + seconds : seconds);
        } else {
          return "00:" + (val < 10 ? "0" + val : val);
        }
      }
    },
  },
};
</script>

<style lang="scss" scoped>
@import "@css/var.scss";

.video-item {
  cursor: default;
  margin-bottom: 20px;
  overflow: hidden;
  border-radius: 0 0 5px 5px;
  border: 1px solid #E7E7E7;

  &.disabled {
    filter: grayscale(90%);
  }

  &.shadow {
    box-shadow: 0px 2px 7px 1px rgba(0, 0, 0, 0.05);
  }

  .img {
    height: 174px;
    display: block;
    position: relative;
    .cover {
      width: 100%;
      height: 100%;
    }
    .time {
      position: absolute;
      right: 10px;
      bottom: 10px;
      z-index: 10;
      display: block;
      width: 63px;
      height: 28px;
      background-color: rgba(0, 0, 0, 0.39);
      color: #fff;
      border-radius: 2px;
      text-align: center;
      line-height: 28px;
    }
    .iconfont {
      display: block;
      font-size: 48px;
      width: 48px;
      height: 48px;
      position: absolute;
      left: 50%;
      top: 50%;
      transform: translate(-50%, -50%);
      color: white;
      opacity: 0.5;
      transition: all 0.3s;
    }

    &:hover {
      .iconfont {
        opacity: 0.8;
      }
    }
  }

  .info {
    padding: 20px;
    background: white;

    .foot {
      overflow: hidden;
      font-size: 14px;
      color: #666;
      margin-top: 18px;
      line-height: 1em;

      .playtime {
        float: left;
      }
      .right-info {
        float: right;

        ::v-deep {
          .item-tool-bar {
            margin-top: 0;
          }
        }
      }
    }
  }

  .title {
    display: block;
    color: #333;
    font-size: 16px;
    line-height: 1em;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;

    &:hover {
      color: $primaryColor;
    }
  }

  .placeholder {
    width: 100%;
    height: 262px;
    background: white;

    .img-plh {
      background-color: $primaryColor1;
      height: 174px;
    }
  }
}
</style>
